export default __webpack_public_path__ + "static/media/photo--lg--misc-14.e5620e3c.jpg";